module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15cYl2e/media/FC-9781035849901.jpg?1718046561868",
      "alt": "This image is the cover for the book Another Adventure for Des Pond, Special Agent"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Another Adventure for Des Pond, Special Agent\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sir Desmond Pond, now Head of MI6, London, feeling the need to get out from behind a desk, decides to investigate a threat from a rogue state himself. A terrorist group is threatening to attack somewhere in England, but where? Des Pond investigates, but will he be able to avert disaster?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gordon S. Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gordon S. Dickson was born near Inverness, Scotland, but left at an early age when his family returned to Northern Ireland. He was educated at secondary and grammar schools, but scraped through English O Level, as essay writing was not his strength. He was employed in the Civil Service for several years but is now retired and has only recently taken up writing books. He enjoys reading several genres of books but mainly historical and detective novels, and a little gardening. Other books by this author are: Verdict Unknown Verdict Unknown, the Sequel The Sheriff of River Bend Des Pond, Special Agent (Comedy) The Wartime Adventures of Harry Harris (A Bartonshire Tale 1) An Impossible Quest (A Bartonshire Tale 2) The Life and Times of Victoria-Ann Penny The Heir… Apparently, and Ashes to Ashes (A Bartonshire tale 3) The Spanish Armada. What if it had all gone wrong? Detective Inspector Denison Stories. The Imposter& The Informers’ Murders.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0